/**
 * Seleção de conexão do "Novo Ticket".
 *
 * #4271 (retorno #8913) — o seletor passou a receber do servidor apenas as
 * conexões que a pessoa pode ver. Isso cria um caso que antes não existia: a
 * conexão padrão DELA (`user.whatsappId`, gravada no cadastro) pode não estar
 * mais entre as permitidas. Pré-selecionada, ficaria um campo que o MUI mostra
 * em branco — e ao salvar mandaria uma conexão proibida, levando 403 na cara
 * de quem não escolheu nada.
 *
 * A regra é a mais simples que não adivinha: vale o que a pessoa pode ver; se
 * sobrou uma só, já vem escolhida; se sobrou mais de uma, ela escolhe.
 */

/**
 * Por que a lista de conexões está vazia?
 *
 * Dois motivos que parecem iguais na tela e pedem respostas opostas — e o
 * critério NÃO é o perfil: um admin restrito também não vê a conexão que não
 * foi vinculada a ele, e mandá-lo "cadastrar uma conexão" seria mentira,
 * porque elas existem e continuam cheias para os outros.
 *
 * @returns `"no-access"` quando o acesso da pessoa é que está vazio;
 *          `"none-registered"` quando não há nada cadastrado e ela pode
 *          resolver isso; `null` quando há conexões na lista.
 */
export function emptyConnectionReason(whatsapps, { restricted, canManage }) {
  if (Array.isArray(whatsapps) && whatsapps.length > 0) return null;
  if (restricted) return "no-access";
  return canManage ? "none-registered" : "no-access";
}

/**
 * Qual conexão deixar selecionada.
 *
 * @param {Array} whatsapps conexões que o servidor devolveu (já filtradas)
 * @param {number|string} preferida a padrão do usuário, ou a escolha atual
 * @returns {number|string} o id a selecionar, ou `""` para "nenhuma"
 */
export function pickConnection(whatsapps, preferida) {
  const ids = (Array.isArray(whatsapps) ? whatsapps : [])
    .map((w) => Number(w?.id))
    // `Number(null)` é 0, e 0 passaria por "finito" — id de verdade é > 0.
    .filter((id) => Number.isFinite(id) && id > 0);

  if (ids.length === 0) return "";
  if (preferida !== null && preferida !== undefined && preferida !== "") {
    const escolhida = Number(preferida);
    if (ids.includes(escolhida)) return escolhida;
  }
  return ids.length === 1 ? ids[0] : "";
}
